fragment ApartmentCardAsset on AssetInterface {
    w366: url @transform(width: 366, height: 244, format: "webp", mode: "crop")
    w600: url @transform(width: 600, height: 400, format: "webp", mode: "crop")
    w720: url @transform(width: 720, height: 480, format: "webp", mode: "crop")
    w1080: url @transform(width: 1080, height: 720, format: "webp", mode: "crop")
    w1440: url @transform(width: 1440, height: 960, format: "webp", mode: "crop")
    w366_avif: url @transform(width: 366, height: 244, format: "avif", mode: "crop")
    w600_avif: url @transform(width: 600, height: 400, format: "avif", mode: "crop")
    w720_avif: url @transform(width: 720, height: 480, format: "avif", mode: "crop")
    w1080_avif: url @transform(width: 1080, height: 720, format: "avif", mode: "crop")
    w1440_avif: url @transform(width: 1440, height: 960, format: "avif", mode: "crop")
}
